var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcompanharObraSensia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 65.6667V28.3334C24 25.7667 26.079 23.6667 28.6719 23.6667H61.3749C63.9444 23.6667 66 25.7667 66 28.3334V65.6667C66 68.2334 63.9444 70.3334 61.3749 70.3334H52.0078V65.6667H59.0649C60.3535 65.6667 61.3982 64.6221 61.3982 63.3334V30.6667C61.3982 29.3781 60.3535 28.3334 59.0649 28.3334H30.9585C29.6698 28.3334 28.6251 29.3781 28.6251 30.6667V63.3334C28.6251 64.6221 29.6698 65.6667 30.9585 65.6667H37.9922V70.3334H28.6719C26.1023 70.3334 24 68.2334 24 65.6667Z",
    fill: "#86AA63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 54.0001C39.0447 54.0001 38 55.0447 38 56.3334V70.3334H52V56.3334C52 55.0448 50.9553 54.0001 49.6667 54.0001H40.3333Z",
    fill: "#86AA63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 33.0001H40.3333V37.6667H35.6667V33.0001Z",
    fill: "#86AA63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 33.0001H49.6667V37.6667H54.3333V33.0001Z",
    fill: "#86AA63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 44.6667H40.3333V49.3334H35.6667V44.6667Z",
    fill: "#86AA63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 44.6667H49.6667V49.3334H54.3333V44.6667Z",
    fill: "#86AA63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07004 10.1803C5.44132 10.1803 3.30989 12.1864 3.30989 14.6611L0 83.5197C0 85.9943 2.13143 88 4.76016 88H84.3125C86.9417 88 89.0732 85.9943 89.0732 83.5197L84.816 4.48079C84.816 2.00614 82.6846 0 80.0554 0L8.07004 10.1803Z",
    fill: "#162C2B",
    fillOpacity: 0.05
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcompanharObraSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acompanhar_obra_sensia.9d7d556bda85d2b57f942dc2a1eb4ef3.svg";